import { createFileRoute } from '@tanstack/react-router';

import { OfflineUpdatePage } from '@/pages/offline-update/offline-update-page';

// Signed-in only, with no entry in src/config/public-routes.ts: the root route's guard sends
// signed-out visitors to /sign-in. The installed offline app's "Check for updates" opens
// /offline?from=<installed version> here. A Safari Dock or iOS Home Screen app adds &handoff=code: it
// cannot be updated by the page navigating, so the page shows an update code to copy instead.
export const Route = createFileRoute('/offline')({
    validateSearch: (search: Record<string, unknown>): { from?: string; handoff?: 'code' } => ({
        from: typeof search.from === 'string' ? search.from : undefined,
        handoff: search.handoff === 'code' ? 'code' : undefined,
    }),
    component: OfflineRoute,
});

// Local wrapper (NOT exported — route files export only Route).
function OfflineRoute() {
    const { from, handoff } = Route.useSearch();
    return <OfflineUpdatePage from={from} handoff={handoff} />;
}
